import { req } from '_s/service'

// 获取验证码
export function getCode(key) {
  return req.get({
    url: `/jeecg-boot/sys/randomImage/${key}`,
  })
}

// 登录
export function login(data) {
  return req.post({
    url: '/jeecg-boot/sys/login',
    data,
  })
}
// 免密登录
export function unlogin(data) {
  return req.post({
    url: '/jeecg-boot/sys/Ulogin',
    data,
  })
}

// title
export function getTitle(key) {
  return req.get({
    url: `/jeecg-boot/shucun/industry/gettitle?AIID=${key}`,
  })
}

// 短信验证码获取
export function getSms(data) {
  return req.post({
    url: '/jeecg-boot/sys/sms',
    data,
  })
}

// 短信登录
export function phoneLogin(data) {
  return req.post({
    url: '/jeecg-boot/sys/phoneLogin',
    data,
  })
}
// 查询所有次屏和次屏下的二级栏目
export function menuList(data, nums) {
  return req.get({
    url: `/jeecg-boot/scbigscreenrouter/scBigscreenrouter/queryList?AIID=${data}&bscenable=${nums}`,
    data,
  })
}
